import {Component, Input, OnInit} from '@angular/core';
import {View} from "src/app/common/view";
import {Handler} from "src/app/common/handler";
import {DashboardContext} from "../../../dashboard/dashboard.context";
import {RefdataUtils} from "../../refdata-utils";
import {uuid} from "../../../../common/utils";
import {
    ContractPeriod,
    ConnectionType,
    EmissionSource,
    ServiceProvider,
    UpsertContractPeriod
} from "@flowmaps-com/flowmaps-typescriptmodels";
import {ContractEntity} from "../../../../handlers/app-entity-handler.service";

@Component({
  selector: 'app-contract-period-details',
  templateUrl: './contract-period-details.component.html',
  styleUrls: ['./contract-period-details.component.scss']
})
@Handler()
export class ContractPeriodDetailsComponent extends View implements OnInit {
  dashboardContext = DashboardContext;
  refDataUtils = RefdataUtils;
  context = DashboardContext;

  @Input() data: ContractPeriodComponentData;
  isNewRecord: boolean;

  ngOnInit(): void {
    this.isNewRecord = !this.data.period || !this.data.period.periodId;
    if (this.isNewRecord) {
      this.data.period = {
        periodId: uuid(),
        data: {
          dateRange: {
            start: this.data.contract.contract.lastEndDate || '',
            end: ''
          },
          offPeakRate: null,
          rate: this.isCooling ? 0 : null,
          feedInRate: null,
          feedInOffPeakRate: null,
          standingCharge: null,
          source: this.data.contract.contract.lastSustainabilitySource || null,
          supplier: null
        },
      };
    }
    if (this.isCooling && this.data.period.data.source?.code === 'Standard cooling'
        && this.data.period.data.source.co2EmissionFactor === 0) {
      this.data.period.data.source = {...this.data.period.data.source, co2EmissionFactor: null};
    }
    if (this.isCooling && !this.data.period.data.source) {
      this.data.period.data.source = {
        connectionType: ConnectionType.Cooling, code: 'Custom cooling',
        name: 'Supplier-specific cooling', co2EmissionFactor: null
      };
    }
  }

  get isCooling(): boolean {
    return this.data.contract.contract.contractData.connectionType === ConnectionType.Cooling;
  }

  updateCoolingFactor(factor: number | null): void {
    this.data.period.data.source = {
      ...this.data.period.data.source,
      connectionType: ConnectionType.Cooling,
      code: 'Custom cooling',
      co2EmissionFactor: factor
    };
  }

  standingChargeUnit = () => "p.m."
  costUnit = () => "€"

  updateContractPeriod = () => {
    this.sendCommand("com.flowmaps.api.organisation.UpsertContractPeriod", <UpsertContractPeriod> {
      contractId: this.data.contract.contract.contractId,
      organisationId: this.data.contract.organisation.organisationId,
      periodId: this.data.period.periodId,
      data: this.data.period.data
    });
  }
}

export interface ContractPeriodComponentData {
  period: ContractPeriod;
  contract: ContractEntity;
  source: EmissionSource;
  supplier: ServiceProvider;
}
